import { render, staticRenderFns } from "./add-purchase-plan.vue?vue&type=template&id=1d5bd1d5&scoped=true&"
import script from "./add-purchase-plan.vue?vue&type=script&lang=js&"
export * from "./add-purchase-plan.vue?vue&type=script&lang=js&"
import style0 from "./add-purchase-plan.vue?vue&type=style&index=0&id=1d5bd1d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5bd1d5",
  null
  
)

export default component.exports